import styles from './search-filter.module.css';
export default function SearchFilter(props: 
		{affiliateAgg: IAffiliateAgg[],
			priceAgg: any[],
			query: string | undefined,
			totalRows: number,
			setValidPriceRanges: Function,
			validPriceRanges: any[],
			validAffiliates: string[],
			setValidAffiliates: Function
			defaultSortOrder: string
			setDefaultSortOrder: Function
		}) {
	return (
		<>
		<div className={styles.searchFilterContainer}>
			<section style={{fontSize: '14px'}}>
				Søkeord <em>"{props.query}"</em><br/>
				Antall treff <strong>{props.totalRows}</strong>
			</section>
			<br/>
			<section>
				<div className={styles.header}>Sortering</div>
				<select onChange={(e) => {
					e.stopPropagation();
					const sortOrder = e.target.value.toString();
					props.setDefaultSortOrder(sortOrder);
				}}>
					<option value="relevance">Mest relevant</option>
					<option value="priceASC">Pris lav til høy</option>
					<option value="priceDESC">Pris høy til lav</option>
				</select>
			</section>
			<br/>
			<section>
				<div  className={styles.header}>Pris</div>			
				{props.priceAgg.map((agg: any, index: number) => {
					return (
						<div key={agg.id + index.toString()}>
							<input type="checkbox" id={agg._id}  name={agg._id} onChange={(() => {
								if (props.validPriceRanges.findIndex((r: {min: number, max: number}) => r.min === agg._id) > -1) {
									const newValidPriceRanges = props.validPriceRanges.filter((range: any) => range.min !== agg._id);
									props.setValidPriceRanges(newValidPriceRanges);
								} else {
									props.setValidPriceRanges([...props.validPriceRanges, {
										min: agg._id,
										max: props.priceAgg[index + 1]?._id - 1 || 990000
									}]);
								}
							})} />
							<label className={styles.aggLabel} htmlFor={agg._id} >{agg._id} - {props.priceAgg[index + 1]?._id - 1 || ''} ({agg.count})</label>
						</div>
					)
				})}				
			</section>
			<br/>	
			<section>
				<div  className={styles.header}>Nettbutikk</div>	
				{props.affiliateAgg
				.map((agg: any, index: number) => {
					return (
						<div key={agg.id + index.toString()}>
							<input type="checkbox" checked={props.validAffiliates.indexOf(agg._id) > -1} id={agg._id}  name={agg._id} onChange={() => {
								if (props.validAffiliates.findIndex((r: string) => r === agg._id) > -1) {
									const newValidAffiliates = props.validAffiliates.filter((a: string) => a !== agg._id);
									props.setValidAffiliates(newValidAffiliates);
								} else {
									props.setValidAffiliates([...props.validAffiliates, agg._id]);
								}
							}} />
							<label className={styles.aggLabel} htmlFor={agg._id} >{`${agg._id.substring(0,1).toUpperCase()}${agg._id.substring(1,agg._id.length).toLowerCase()}`} ({agg.numberOfProducts})</label>
						</div>
					)
				})}
			</section>
			<br/>
			<br/>
			<a href="https://www.nytelse.no/tt/?tt=12509_2223084_263403_&amp;r=" target="_blank" rel="sponsored nofollow"><img src="https://ti.tradetracker.net/?c=12509&amp;m=2223084&amp;a=263403&amp;r=&amp;t=html" width="180" height="500"  alt="Spar 200kr på kjøp over 500!" /></a>
			<br/>
			<br/>
			<a href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=101288" target="_blank" rel="nofollow noopener">
				<img src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=101288" alt="Massasjepistoler" />
			</a>
		</div>
		</>
	)
}

export interface IAffiliateAgg {
	_id: string,
	numberOfProducts: number
} 